function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var module;
// LICENSE_CODE ZON ISC
'use strict'; /*jslint node:true, browser:true, es9:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  if (is_node) ;else ;
  define(['/util/sprintf.js', '/util/conv.js'], function (sprintf, conv) {
    var E = {};
    var ver_regexp = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    E._expand = function (ver) {
      var v;
      if (!ver) return '';
      if (!(v = ver_regexp.exec(ver))) return;
      return sprintf('%03d.%03d.%03d', +v[1], +v[2], +v[3]);
    };
    E.expand = conv.cache_str_fn(E._expand);
    E._trim = function (ver) {
      var v;
      if (!ver) return '';
      if (!(v = ver_regexp.exec(ver))) return;
      return '' + +v[1] + '.' + +v[2] + '.' + +v[3];
    };
    E.trim = conv.cache_str_fn(E._trim);
    E._cmp = function (v1, v2) {
      if (!v1 || !v2) return +!!v1 - +!!v2;
      var _v1 = ('' + v1).split('.'),
        _v2 = ('' + v2).split('.'),
        i;
      for (i = 0; i < _v1.length && i < _v2.length && +_v1[i] == +_v2[i]; i++);
      if (_v1.length == i || _v2.length == i) return _v1.length - _v2.length;
      return +_v1[i] - +_v2[i];
    };
    E.cmp = conv.cache_str_fn2(E._cmp);
    E._valid = function (v) {
      return ver_regexp.test('' + v);
    };
    var version_valid_cache = {};
    E.valid = function (v) {
      var cache = version_valid_cache,
        res;
      v = '' + v; // accept non-string (always false)
      if (v in cache) return cache[v];
      if (res = E._valid(v)) cache[v] = res; // cache only valid versions
      return res;
    };
    function iter_ver(version, cb) {
      var v;
      if (!E.valid(version)) return version;
      v = version.split('.');
      for (var i = v.length - 1; i >= 0 && !cb(v, i); i--);
      return v.join('.');
    }
    E.inc = function (version) {
      return iter_ver(version, function (v, i) {
        if (v[i] < 999) {
          v[i] = +v[i] + 1;
          return true;
        }
        v[i] = 0;
      });
    };
    E.dec = function (version) {
      return iter_ver(version, function (v, i) {
        if (v[i] > 0) {
          v[i] = +v[i] - 1;
          return true;
        }
        v[i] = 999;
      });
    };
    E.get_max = function (versions, cmp) {
      var v, i;
      versions = versions.sort(cmp || function (v1, v2) {
        return E.cmp(v2.version, v1.version);
      });
      for (i = 0; i < versions.length; i++) {
        v = versions[i];
        if (+v.isbranch || !+v.soft_tag || !+v.onsymbol || v.repository != 'zon' || !E.valid(v.version)) {
          continue;
        }
        return v.version;
      }
    };
    E.cmp_get_min = function (versions, cmp) {
      if (versions.length <= 0) return;
      return versions.sort(cmp ? function (v1, v2) {
        return -cmp(v1, v2);
      } : function (v1, v2) {
        return -E.cmp(v2, v1);
      })[0];
    };
    E.hash = function (ver) {
      return conv.md5('wQ' + ver + '\n', 8);
    };
    E.ver2int = function (ver) {
      var m = ver_regexp.exec(ver);
      return m && +m[1] * 1000000 + +m[2] * 1000 + +m[3];
    };
    E.int2ver = function (n) {
      if (!n) return '';
      var n3 = n % 1000;
      n = n / 1000 | 0;
      var n2 = n % 1000;
      n = n / 1000 | 0;
      return n + '.' + n2 + '.' + n3;
    };
    // major.minor.patch -> major.minor
    E.get_major_minor = function (ver) {
      return ver && ver.replace(/^(\d+(\.\d+)?).*$/, '$1');
    };
    E.win_build2ver = function (v) {
      if (!/^\d+\.\d+/.test(v)) v = '0.0';
      var vv = v.split('.');
      var ver = +vv.slice(0, 2).join('.');
      var build = vv.length >= 3 ? +vv[2] : 0;
      return ver >= 10 && build >= 21996 ? 'v11' : ver >= 10 ? 'v10' : ver >= 6.3 ? 'v8.1' : ver >= 6.2 ? 'v8' : ver >= 6.1 ? 'v7' : ver >= 6.0 ? 'vista' : ver >= 5.2 ? 'xp' : 'other';
    };
    E.get_ea_rg_version = function (version) {
      // maksimvi: EarnApp and RewardGum have different versioning:
      // 0.500.000 + ZON_VERSION
      var delta = 500000;
      var parse = v => v.split('.').map(Number);
      var _parse = parse(version),
        _parse2 = _slicedToArray(_parse, 3),
        maj = _parse2[0],
        min = _parse2[1],
        pat = _parse2[2];
      var version_int = (maj * 1000 + min) * 1000 + pat + delta;
      var patch = version_int % 1000;
      var minor = Math.floor(version_int / 1000) % 1000;
      var major = Math.floor(version_int / 1000000);
      return `${major}.${minor}.${patch}`;
    };

    // reverse earnapp/rewardgum version: get zon_version back
    E.rev_ea_rg_version = function (version) {
      if (!version) return version;
      var delta = 500000;
      var parse = v => v.split('.').map(Number);
      var _parse3 = parse(version),
        _parse4 = _slicedToArray(_parse3, 3),
        maj = _parse4[0],
        min = _parse4[1],
        pat = _parse4[2];
      var version_int = (maj * 1000 + min) * 1000 + pat - delta;
      if (version_int < 0) return version;
      var patch = version_int % 1000;
      var minor = Math.floor(version_int / 1000) % 1000;
      var major = Math.floor(version_int / 1000000);
      return `${major}.${minor}.${patch}`;
    };
    return E;
  });
})();